// @flow
// import {handleErrors as handle} from './handle-errors';

import type {Store as ReduxStore} from 'redux';
import type {Type, Types, HandleError} from './typedef';


type HandleErrors = HandleError => (store: ReduxStore<*, *>) =>
    (next: ({|
        type: Type,
        error: { reason: string, message: string },
        response?: *,
    |}) => ({ type: Type })) =>
        ({
            responseData: *,
            response: Response,
            types: Types,
            error: { reason: string, message: string },
        }) => *;

export const handleErrors: HandleErrors = handle => store => next => action => {

    const actionButParams = () => {
        // eslint-disable-next-line no-unused-vars
        const {responseData, response, types, ...finalAction} = action;
        return finalAction;
    };

    if (action.types) {
        return handle({
            responseData: action.responseData || action.error,
            response: action.response,
            store,
            types: action.types
        }).then(
            (response: any) => {
                return next({
                    ...actionButParams(),
                    type: action.types[1],
                    ...response ? {response} : {}
                });
            },
            (err: any) => {
                const errorMsg = Array.isArray(err) ? err.join(' ') : err;
                return next({
                    ...actionButParams(),
                    type: action.types[2],
                    error: errorMsg
                });
            }
        );
    }

    return next(action);

};

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./typedef");
